import { render, staticRenderFns } from "./SwingCardShell.vue?vue&type=template&id=18ba6af2&scoped=true"
import script from "./SwingCardShell.vue?vue&type=script&lang=js"
export * from "./SwingCardShell.vue?vue&type=script&lang=js"
import style0 from "./SwingCardShell.vue?vue&type=style&index=0&id=18ba6af2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ba6af2",
  null
  
)

export default component.exports